import '../index.css';

function PrimaryButton() {
  return (
      <div className="bg-logo text-white py-3 px-6 rounded-lg font-bold text.base md:text-l my-6 w-200pc hover:opacity-70 cursor-pointer">Discover</div>
  );
}

export default PrimaryButton;
